import PolicyMigratorModal from './PolicyMigratorModal'

export default PolicyMigratorModal
